<template>
  <div class="statistics">
    <div class="container">
      <div class="text-center">
        <h1 class="font-weight-bold">{{ $t("statistics.lastMonth") }}</h1>
      </div>
      <div
        class="d-flex justify-content-between align-items-center mt-md-5 mt-4"
      >
        <div class="text-center border-right flex-grow-1">
          <h2 class="font-weight-bold">{{ propertiesCountData.world | numberFormat }}</h2>
          <p>{{ $t("statistics.propertiesListed") }}</p>
        </div>
        <div class="text-center flex-grow-1">
          <h2 class="font-weight-bold">{{ $t("statistics.languageCount") }}</h2>
          <p>{{ $t("statistics.languagesSupported") }}</p>
        </div>
        <div class="text-center border-left flex-grow-1">
          <h2 class="font-weight-bold">{{ $t("statistics.costValue") }}</h2>
          <p>{{ $t("statistics.costForGuestAndHost") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "StatisticsSection",
  data() {
    return {
      propertiesCountData: {},
    };
  },
  async mounted() {
    const response = await this.countProperties();
    const { data } = response.data;
    this.propertiesCountData = data;
  },
  methods: {
    ...mapActions("property", ["countProperties"]),
  }
};
</script>

<style scoped>
.statistics {
  background: #444;
  color: #fff;
  padding: 60px;
}

@media only screen and (max-width: 500px) {
  .statistics {
    padding: 30px 0;
  }

  .statistics h1 {
    font-size: 26px;
  }

  .statistics h2 {
    font-size: 18px;
  }

  .statistics p {
    font-size: 13px;
  }
}
</style>
